<!-- Loader -->
<div id="preloader" *ngIf="isLoading">
  <div id="status">
    <div class="spinner"></div>
  </div>
</div>
<router-outlet></router-outlet>
